import React from "react";

import styles from "./Mission.module.scss";

const Mission = () => {
  return (
    <div className={styles.layoutWrapper}>
      <h1>Our Mission</h1>
    </div>
  );
};

export default Mission;